import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Text } from '~/components';
import { isWeb } from '~/utils/device';

interface Props {
  width: number;
  index: number;
  month: string;
  selected: boolean;
  onPress(index: number): void;
}

const MonthItem: React.FC<Props> = ({
  width,
  month,
  index,
  selected,
  onPress,
}) => {
  return (
    <TouchableOpacity
      activeOpacity={0.6}
      onPress={() => onPress(index)}
      style={!isWeb && { width }}
    >
      <Text
        className={`text-light-100 text-center ${
          selected ? 'opactity-100' : 'opacity-70'
        }  text-lg`}
      >
        {month}
      </Text>
    </TouchableOpacity>
  );
};

export default MonthItem;
